const getters = {
    ecom: (state) => state.ecom,
    loading: state => state.loading,
    
};

export default getters;